import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { LOCAL_STORAGE, SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import { Observable, of } from 'rxjs';
import { ErrorModel } from 'src/app/core/models/error.model';
import { DialogService } from 'src/app/layout/services/dialog.service';
import { FavoritoService } from 'src/app/main/favorite/services/favorito.service';
import { FavoritoModel } from 'src/app/main/hao/models/favorito.model';
import { PageEvent as CustomPipefyPageEvent } from 'src/app/main/pipe-pagination/pipe-pagination.component';
import { HeadhunterModel } from '../../models/headhunter.model';
import { DominioService } from '../../services/dominio.service';
import { HeadhunterService } from '../../services/headhunter.service';
import { TerritorioService } from '../../services/territorio.service';
import * as _ from 'lodash';
import { HeadhunterFilterModel } from '../../models/headhunter-filter.model';
import { MdePopoverTrigger } from '@material-extended/mde';
import { PageEvent } from '@angular/material/paginator';
import { PageModel } from 'src/app/core/models/page.model';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {

  area$: Observable<any>;
  selectedArea: number;

  funcao$: Observable<any>;
  selectedFuncao: number;

  nivel$: Observable<any>;
  selectedNivel: number;

  uf$: Observable<any>;
  selectedUf: number;

  status$: Observable<any>;
  selectedStatus: string;

  formGroup: FormGroup;

  readonly STORAGE_KEY = '_filter_';

  displayedColumns: string[] = [
    'favorito', 'foto', 'candidato', 'mercado', 'cargo',
    'senioridade', 'disponibilidadeGeografica' , 'status', 'contatos'
  ];
  loading = false;
  dataSource = new MatTableDataSource<HeadhunterModel>();
  pageSize = 10;
  pageRanger = [2, 10, 20, 50];
  allFavorite: FavoritoModel[] = [];
  private firstPage = 0;
  length;
  isPipefyPageEvent = true;

  @ViewChild('popoverTrigger') popoverTrigger: MdePopoverTrigger

  constructor(
      private headhunterService: HeadhunterService,
      private dialogService: DialogService,
      private favoritoService: FavoritoService,
      private router: Router,
      public dialog: MatDialog,
      private territorioService: TerritorioService,
      private dominioService: DominioService,
      private formBuilder: FormBuilder,
      private activatedRoute: ActivatedRoute,
      @Inject(SESSION_STORAGE) private storageService: StorageService,
      @Inject(LOCAL_STORAGE) private localStorageService: StorageService,
  ) { }

  ngOnInit(): void {
    console.log(this.firstPage);
    this.getAllFavorite();

    this.loadHeadhunter('', '', this.pageSize);

    this.formGroup = this.formBuilder.group({
      area: [null],
      funcao: [null],
      nivel: [null],
      uf: [null],
      status: [null],
      filterDetail: [true],
      page: [this.firstPage],
      size: [this.pageSize],
    });

    this.area$ = this.dominioService.getMercados();

    this.funcao$ = this.dominioService.getCargos();

    this.nivel$ = of([
      {
        id: 'Junior',
        name: 'Junior'
      },
      {
        id: 'Pleno',
        name: 'Pleno'
      },
      {
        id: 'Sênior',
        name: 'Sênior'
      },
      {
        id: 'Especialista',
        name: 'Especialista'
      }
    ]);

    this.uf$ = this.territorioService.getAll();

    this.status$ = of([
      {
        id: 'Em transição de carreira',
        name: 'Em transição de carreira'
      },
      {
        id: 'Em busca de recolocação profissional',
        name: 'Em busca de recolocação profissional'
      }
    ]);

    /*this.status$ = of([
      {
        id: 'Empregado',
        name: 'Empregado'
      },
      {
        id: 'Desempregado',
        name: 'Desempregado'
      }
    ]);*/

    /*this.activatedRoute.params.subscribe(params => {
      let hasParams: boolean;

      if (params['after'] || params['before'] || params['pageSize']) {
        hasParams = Object.keys(params).length > 1;
      }
      else {
        hasParams = Object.keys(params).length > 0;
      }

      if (hasParams) {
        this.setFilterByQueryString(params);
      } else {
        if (this.storageService.has(this.STORAGE_KEY)) {
          let storedValues = this.storageService.get(this.STORAGE_KEY);
          this.formGroup.patchValue(storedValues);
        }
      }
    });*/
  }

  private loadHeadhunter(after: string, before: string, pageSize: number): void {
    this.isPipefyPageEvent = true;
    this.loading = true
    this.headhunterService.getData(after, before, pageSize).subscribe(result => {
      this.dataSource.data = result;
    }, (error: ErrorModel) => {
      console.log(error);
      const msgErro = 'Erro ao carregar dados do servidor';
      this.dialogService.showAlert(msgErro);
    }).add(() => {
      this.loading = false;
    });
  }

  pageEvent(e: CustomPipefyPageEvent) {
    this.loading = e.loading;
    this.loadHeadhunter((e.forward) ? e.startCursor : '', (e.back) ? e.endCursor : '', e.pageSize);
  }

  removeFavorito(codigo: string) {
    this.favoritoService.remove(Number(codigo)).subscribe(results => {
    }, (error: ErrorModel) => {
      console.log(error);
    });
  }

  addFavorito(codigo: string, pipeId: any) {
    this.favoritoService.add({cardId: codigo, pipeId: pipeId}).subscribe(results => {
    }, (error: ErrorModel) => {
      console.log(error);
    });
  }

  private getAllFavorite(): void {
    this.favoritoService.getAllPhh().subscribe(favorite => {
      this.allFavorite = favorite;
    }, (error: ErrorModel) => {
      console.log(error);
    });
  }

  clickNavigation(s: string): any {
    return this.router.navigate([s]);
  }

  aplicarFiltro(): void {
    this.storageService.set(this.STORAGE_KEY, this.formGroup.value);
    this.isPipefyPageEvent = false;
    this.loadDataGrid();
  }

  changePage(e: PageEvent): void {
    this.isPipefyPageEvent = false;
    this.formGroup.get('page').setValue(e.pageIndex);
    this.formGroup.get('size').setValue(e.pageSize);
    this.loadDataGrid();
  }

  private loadDataGrid(): void {
    this.loading = true;
    this.headhunterService.getDataByFilter(this.formGroup.value).subscribe((results: PageModel<HeadhunterModel>) => {
      this.dataSource.data = results.content;
      this.length = results.totalElements;
    }, (error: ErrorModel) => {
      console.log(error);
    }).add(() => {
      this.loading = false;
      this.popoverTrigger.closePopover();
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: (_.pickBy(this.createFiltro()))
      });
    });
  }

  private createFiltro(): HeadhunterFilterModel {
    const multiploFiltro = new HeadhunterFilterModel();
    const values = this.formGroup.value;

    multiploFiltro.area = values.area ? [values.area] : null;
    multiploFiltro.funcao = values.funcao ? [values.funcao] : null;
    multiploFiltro.nivel = values.nivel ? [values.nivel] : null;
    multiploFiltro.status = values.status ? [values.status] : null;
    multiploFiltro.filterDetail = values.filterDetail;

    return multiploFiltro;
  }

  private getValueParam(value) {
    if (!value) {
      return null;
    }
    return Array.isArray(value) ? value : Array(value);
  }

  private setFilterByQueryString(params: Params) {
    let filtro = new HeadhunterFilterModel();

    if (params.area) {
      filtro.area = this.getValueParam(params.area);
    }

    if (params.funcao) {
      filtro.funcao = this.getValueParam(params.funcao);
    }

    if (params.nivel) {
      filtro.nivel = this.getValueParam(params.nivel);
    }

    if (params.uf) {
      filtro.uf = this.getValueParam(params.uf);
    }

    if (params.status) {
      filtro.status = this.getValueParam(params.status);
    }

    filtro.filterDetail = true;

    this.formGroup.patchValue(filtro);
  }
}
